module.exports = __webpack_public_path__ + "static/media/4.79ee3c7b.jpg";